import { linkClasses } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiLink(): Components['MuiLink'] {
  return {
    defaultProps: {
      underline: 'none',
      color: 'primary',
    },
    styleOverrides: {
      root: {
        [`&.${linkClasses.focusVisible}`]: {
          textDecoration: 'underline',
        },
      },
    },
  };
}
